<template>
  <YdDialog
    :title="'有效线路'"
    :visible.sync="showVisible"
    append-to-body
    @close="close"
    width="60%"
  >
    <el-row>
      <el-col>
        <el-form ref="routeQueryForm" :model="form" :inline="true" size="mini">
          <el-form-item label="线路名称" prop="lineName">
            <el-input v-model="form.lineName" clearable placeholder="请输入内容" />
          </el-form-item>
          <!--        线路类型（1普通线；2旅游线；3校园线；4接驳线；5机场线-->
          <el-form-item label="线路类型" prop="type">
            <yd-common-selector v-model="form.type" :options="options" />
          </el-form-item>
          <el-form-item label="路线状态" prop="status">
            <yd-common-selector v-model="form.status" :options="stateOptions" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="loading" @click="search"
              >筛选</el-button
            >
            <el-button type="danger" icon="el-icon-delete" :loading="loading" @click="reset"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <yd-table
      :loading="loading"
      :pagination="pagesOptions"
      :data="tableData"
      row-key="userId"
      @selection-change="tableSelectChange"
      @onChange="onTableChange"
      :settings="{
        showSelect: true
      }"
    >
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        align="center"
        :prop="item.filed"
        :label="item.title"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="item.filed === 'status'">
            <el-tag size="mini" type="success" v-if="scope.row.status === 1">正常</el-tag>
            <el-tag size="mini" type="info" v-if="scope.row.status === 2">下架</el-tag>
          </div>
          <span v-else>{{ scope.row[`${item.filed}`] }}</span>
        </template>
      </el-table-column>
    </yd-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
  </YdDialog>
</template>

<script >
import { ref, computed, defineExpose } from '@vue/composition-api';
import { useTableList } from '@/hooks';
import { getRoteList } from '@/api/transport/routeset';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const stateOptions = [{
    label: '正常',
    value: 1
  }, {
    label: '下架',
    value: 2
  }];
  const options = [{
    label: '普通线',
    value: 1
  }, {
    label: '旅游线',
    value: 2
  }, {
    label: '校园线',
    value: 3
  }, {
    label: '接驳线',
    value: 4
  }, {
    label: '机场线',
    value: 5
  }];
  const {
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    search,
    reset
  } = useTableList(getRoteList, {});
  const tableColumns = [{
    key: 1,
    title: 'ID',
    filed: 'id'
  }, {
    key: 2,
    title: '线路名称',
    filed: 'lineName'
  }, {
    key: 3,
    title: '出发城市',
    filed: 'startCityName'
  }, {
    key: 4,
    title: '目的城市',
    filed: 'endCityName'
  }, {
    key: 5,
    title: '出发地址',
    filed: 'startAddress'
  }, {
    key: 6,
    title: '到达地址',
    filed: 'endAddress'
  }, {
    key: 7,
    title: '行程时长',
    filed: 'durationStr'
  }, {
    key: 8,
    title: '线路类型',
    filed: 'typeStr'
  }, {
    key: 9,
    title: '状态',
    filed: 'status'
  }];
  const pagesOptions = computed(() => ({
    total: pageState.value.total,
    current: pageState.value.currentPage,
    size: pageState.value.pageSize
  }));
  const onTableChange = ({
    type,
    current,
    pageSize
  }) => {
    if (type === 'sizeChange') {
      handleSizeChange(pageSize);
    }
    if (type === 'currentChange' || type === 'fresh') {
      handleCurrentChange(current);
    }
  };
  const emits = __ctx.emit;
  const showVisible = ref(false);
  const form = searchParam;
  const close = () => {
    reset();
    showVisible.value = false;
    emits('close');
  };
  const open = val => {
    showVisible.value = val;
  };
  const selectRowArr = ref([]);
  // 表格选中事件
  const tableSelectChange = selection => {
    selectRowArr.value = [...selection];
  };
  const save = () => {
    emits('lineSubmit', selectRowArr.value, 'line');
    selectRowArr.value = [];
    close();
  };
  return Object.assign({
    stateOptions,
    options,
    loading,
    tableData,
    search,
    reset,
    tableColumns,
    pagesOptions,
    onTableChange,
    showVisible,
    form,
    close,
    tableSelectChange,
    save
  }, {
    open
  });
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
